<template lang="html">
<div class="pgInner userFill" :style="'height:' + pageH + 'px;'">
    <el-scrollbar ref="pgScroller" style="height:100%;">

        <div class="pgHead">
            <span>朝企家 | 帐号注册</span>
            <el-button @click="goReturn" class="btn" size="small" type="primary">返回</el-button>
        </div>

        <div class="pgBody" :style="'height:' + (pageH-60) + 'px;'" >

          <el-steps :active="0" finish-status="success">
              <el-step title="基本信息"></el-step>
              <el-step title="完成注册"></el-step>
              <el-step title="平台审核"></el-step>
          </el-steps>

            <div v-if="pgress==1" class="inpCage">
                  <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true">

                      <div class="inpLine inpLine-width">
                          <el-form-item prop="jiexiangId">
                                <tree-select code="szjx"
                                    :selectId="params.jiexiangId"
                                    :moreSelect="false"
                                    paramsKey="jiexiang"
                                    @selectChange="selectChange"
                                    plaText="所在街乡（必选）" />
                            </el-form-item>
                      </div>
                      <div class="inpLine inpLine-width">
                          <el-form-item prop="name">
                              <el-input v-model="params.name" placeholder="姓名（必填）" />
                          </el-form-item>
                      </div>
                      <div class="inpLine inpLine-width">
                          <el-form-item prop="danwei">
                              <el-input v-model="params.danwei" :placeholder="danweiTip" />
                          </el-form-item>
                      </div>
                      <div class="inpLine inpLine-width" v-if="type==1">
                          <el-form-item prop="ownePark">
                              <el-input v-model="params.ownePark" placeholder="负责的楼宇/园区（必填）" />
                          </el-form-item>
                      </div>
                      
                      <div class="inpLine inpLine-width">
                          <el-form-item prop="phone">
                              <el-input v-model="params.phone" placeholder="手机号" />
                          </el-form-item>
                      </div>
                      <div class="inpLine codeLine">
                          <el-form-item prop="code">
                                <el-input v-model="params.code" placeholder="请输入验证码" />
                          </el-form-item>
                          <el-button v-if="wTime===0" @click="getCode" class="cbtn" type="primary">获取验证码</el-button>
                          <el-button v-else disabled class="cbtn disbtn" type="primary">{{wTime}}s</el-button>
                          <div class="div-tips">暂不支持北京以外的中国移动号码接收短信</div>
                      </div>
                      <div class="inpLine inpLine-width">
                          <el-form-item prop="email">
                              <el-input v-model="params.email" placeholder="邮箱" />
                          </el-form-item>
                      </div>
                      <!-- <div class="firmCheck">
                          <el-checkbox v-model="checked"></el-checkbox>
                          <span>我同意</span>
                          <span class="spanLink">《申请承诺及须知》</span>
                      </div> -->

                      <div class="inpLine inpLine-width subline">
                          <el-button @click="goSet" type="primary">注册</el-button>
                      </div>
                  </el-form>
            </div>



        </div>

    </el-scrollbar>

</div>
</template>

<script>
import Cookies from 'js-cookie';
import { paramsCreate } from "@/utils/iparams";
import { requestSmsCode,saveUserRegister } from "@/api/pgMent/userMent";

var mobelPhone = (rule,val,callback) => {      // 手机验证
     var pattern = /^1(3|4|5|6|7|8|9)\d{9}$/;

     if(val == ''){
         callback(new Error('请输入手机号'));
     }else if(!pattern.test(val)){
         callback(new Error('手机号格式错误！'));
     }else{
         callback();
     }
};

var email = function(rule,val,callback){
		var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
		if(val==''){
            callback(new Error('请输入邮箱'));
		}else if(reg.test(val)){
            callback();
		}else{
            callback(new Error('邮箱格式不正确'));
		}
	};
export default {

    data(){
        return{
            pageH:'',
            pgress:1,
            isWait:false,
            userData:{},
            wTime:0,
            type:0,
            danweiTip:'维护人所属单位名称（必填）',
            params:{
                name:'',
                danwei:'',
                ownePark:'',
                phone:'',
                email:'',
                code:'',
                jiexiangId:'',
                jiexiang:'',
                type:0,
            },
            checked:false,
            rules:{
                name:[{ required: true,message: '请输入姓名',trigger: 'blur' }],
                danwei:[{ required: true,message: '请输入所属单位',trigger: 'blur' }],
                ownePark:[{ required: true,message: '请输入所属功能区',trigger: 'blur' }],
                // email:[{ validator: email,trigger: 'blur' }],
                phone:[{ validator: mobelPhone,trigger: 'blur' }],
                code:[{ required: true,message: '请输入短信验证码',trigger: 'blur' }],
                jiexiangId:[{ required: true,message: '请选择所在街乡',trigger: 'blur' }],
                
            }
        }
    },
    methods:{

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goWait:function(){
            var vues = this;
            vues.wTime = 60;
            vues.wait = setInterval(function(){
                vues.wTime--;
                if(vues.wTime === 0){
                    clearInterval(vues.wait);
                }
            },1000)
        },

        getCode:function(){
            var cTime = 60;
            var vues = this;
            if(!this.params.phone){
                this.$message.error('请先填写手机号')
            }else{
                var newPms = paramsCreate();
                requestSmsCode({
                    cellphone:this.params.phone,
                    type:4,
                    t:newPms.t,
                    r:newPms.r,
                    s:newPms.s
                }).then(res => {
                    vues.goWait();
                })
            }
        },

        formClear:function(){
            for(var key in this.params){
                this.params[key] = '';
            }
        },
        selectChange(e){
         
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
            console.log(this.params);
        },
        goSet:function(){
            var vues = this;
            vues.$refs.ruleForm.validate((valid) => {
                if(valid){
                    saveUserRegister({'userRegister':{
                        phone:vues.params.phone,
                        code:vues.params.code,
                        name:vues.params.name,
                        danwei:vues.params.danwei,
                        ownePark:vues.params.ownePark,
                        email:vues.params.email,
                        jiexiangId:vues.params.jiexiangId,
                        jiexiang:vues.params.jiexiang,
                        status:0,
                        type:vues.params.type,
                    }}).then(res => {
                        this.$message({
                                  showClose:true,
                                  message:'操作成功！',
                                  type:'success'
                              });
                        Cookies.set('registers',JSON.stringify(vues.params));
                        vues.$router.push('success_register');
                    })

                }
            })
        },

        goReturn:function(){
            this.$router.go(-1);
        }

    },

    created:function(){
        var vues = this;
        this.type=this.$route.query.type;
        this.params.type=this.type;
        if(this.type==2){
            this.danweiTip = '所属单位及科室';
            this.rules={
                name:[{ required: true,message: '请输入姓名',trigger: 'blur' }],
                // ownePark:[{ required: true,message: '请输入所属园区',trigger: 'blur' }],
                phone:[{ validator: mobelPhone,trigger: 'blur' }],
                code:[{ required: true,message: '请输入短信验证码',trigger: 'blur' }],
                jiexiangId:[{ required: true,message: '请选择所在街乡',trigger: 'blur' }],
            }
        }
        this.userData = this.$store.getters.userInfo;

        this.pageFix();


    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.pgHead{
     height: 60px;
     line-height: 60px;
     padding-left: 30px;
     font-size: 16px;

     .btn{
         float: right;
         width: 80px;
         margin-right: 30px;
         margin-top: 15px;
     }
}

.seek-blcok{
     margin: 0 30px;
     background: white;
     padding: 30px;

     .ttl{
         font-size: 15px;
         font-weight:bold;
     }

     .content{
         margin-top: 20px;
     }

}

.pgBody{
    margin: 0 30px;
    padding: 30px;
    background: white;

    .inpCage{
        width: 765px;
        margin: 0 auto;
        margin-top: 60px;
        // margin-left: 300px;
        .inpLine{
            margin-bottom: 18px;
            .el-form-item{
                margin-bottom: 0px;
                display: block;
            }
            .el-cascader{
                width:450px;
            }
        }
        .inpLine-width{
            width:450px;
        }
        .codeLine{
           .el-input{
               width: 320px;
           }
            .cbtn{
                // float: right;
                margin-left: 15px;
            }

            .el-form-item{
                display: inline-block;
            }
            .div-tips{
                display: inline-block;
            }
        }

        .subline{
            text-align: center;
            margin-top: 30px;
            .el-button{
                width: 100%;
                height: 45px;
            }
        }

        .sucLine{
           color: #999999;
           text-align: center;
           margin-bottom: 80px;

           .icon{
               font-size: 30px;
               vertical-align: middle;
               margin-bottom: 6px;
           }
        }

        .firmCheck{
            font-size: 14px;
            color: #666666;

            .el-checkbox{
                margin-right: 3px;
            }

            .spanLink{
                color: #409EFF;
                cursor: pointer;
            }
        }


    }
}

.disbtn{
    pointer-events: none;
    width: 112px;
}

.userFill .el-form-item{
     display: inline-block;
}

</style>



// WEBPACK FOOTER //
// userFill.vue?7defe702